module.exports = __webpack_public_path__ + "img/banner01.543d6aab.png";